import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row justify-between" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxFilterCheckBox from "src/components/filter/SfxFilterCheckBox.vue"
import { getItemClassListData } from "src/util/functions/entityData"
import { FilterCheckBox } from "src/components/filter/SfxFilterCheckBox.vue"
import { ItemClass } from "src/util/types/dataModels/itemClass"
import { computed, onBeforeMount, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterTecModeItemClasses',
  props: {
  itemClassIds: {
    type: Array as PropType<string[]>,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK } = useDialogPluginComponent()

const itemClasses = ref<ItemClass[]>([])
const itemClassData = ref<FilterCheckBox[]>([])

const availableClasses = computed(() => itemClassData.value.filter(({ isChecked }) => !isChecked))
const selectedClasses = computed(() => itemClassData.value.filter(({ isChecked }) => isChecked))

const showSeparator = computed(
  () => selectedClasses.value.length > 0 && availableClasses.value.length > 0
)

//endregion

//region Lifecycle

onBeforeMount(async () => {
  const itemClassList = await getItemClassListData()
  itemClasses.value = itemClassList.map((itemClass) => itemClass.toMutableJSON())

  itemClassData.value = itemClasses.value.map<FilterCheckBox>((itemClass) => {
    return {
      id: itemClass.id,
      label: itemClass.designation,
      isChecked: false,
    }
  })

  if (props.itemClassIds && props.itemClassIds.length > 0) {
    for (const itemClass of itemClassData.value) {
      itemClass.isChecked = props.itemClassIds.includes(itemClass.id)
    }
  }
})

//endregion

//region Functions

async function handleToggle(id: string) {
  const index = itemClassData.value.findIndex((itemClass) => itemClass.id === id)
  itemClassData.value[index].isChecked = !itemClassData.value[index].isChecked
}

function selectAll() {
  itemClassData.value = itemClassData.value.map((itemClass) => {
    return {
      ...itemClass,
      isChecked: true,
    }
  })
}

function selectNone() {
  itemClassData.value = itemClassData.value.map((itemClass) => {
    return {
      ...itemClass,
      isChecked: false,
    }
  })
}

function saveFilters() {
  onDialogOK(selectedClasses.value.map((itemClass) => itemClass.id))
}

function resetFilters() {
  onDialogOK([])
}

//endregion

//region Setup Code
//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_performed_work_item_class")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(SfxBtnLink, {
                  class: "q-pl-none",
                  label: _unref(t)('sfxButtons.btn_select_none'),
                  onClick: selectNone
                }, null, 8, ["label"]),
                _createVNode(SfxBtnLink, {
                  class: "q-pr-none",
                  label: _unref(t)('sfxButtons.btn_select_all'),
                  onClick: selectAll
                }, null, 8, ["label"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedClasses.value, (itemClass) => {
                return (_openBlock(), _createBlock(SfxFilterCheckBox, {
                  key: itemClass.id,
                  "check-box-data": itemClass,
                  onCheckboxClicked: handleToggle
                }, null, 8, ["check-box-data"]))
              }), 128)),
              (showSeparator.value)
                ? (_openBlock(), _createBlock(SfxSeparator, {
                    key: 0,
                    dimmed: ""
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableClasses.value, (itemClass) => {
                return (_openBlock(), _createBlock(SfxFilterCheckBox, {
                  key: itemClass.id,
                  "check-box-data": itemClass,
                  onCheckboxClicked: handleToggle
                }, null, 8, ["check-box-data"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col q-mr-sm",
                onClick: resetFilters,
                label: _unref(t)('sfxButtons.btn_reset')
              }, null, 8, ["label"]),
              _createVNode(SfxBtn, {
                class: "col",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})